import { ENTITY_NAMES } from "../entityTypes/entityTypes";

export const PAGE_TITLES = {
  HOME: "Home",
  ACCOUNTING: "Accounting",
  AUDIT_LOG: "Audit Log",
  ACCOUNTS_RECEIVABLE: "Accounts Receivable",
  PAYMENTS: "Payments",
  PAYMENT: "Payment",
  POST_PAYMENT: "Post Payment",
  CUSTOMERS: "Customers",
  CUSTOMER: "Customer",
  VENDORS: "Vendors",
  VENDOR: "Vendor",
  DEPARTMENTS: "Departments",
  DEPARTMENT: "Department",
  HOLIDAYS: "Holiday Schedule",
  HOLIDAY: "Holiday",
  ADD_HOLIDAY: "Add Holiday",
  ADD_DEPARTMENT: "Add Department",
  USERS: "Users",
  USER: "User",
  ADD_USER: "Add User",
  ROLES: "Roles and Permissions",
  ROLE: "Role",
  ADD_ROLE: "Add Role",
  ORDER_TEMPLATES: ENTITY_NAMES.ORDER_TEMPLATES,
  ORDER_TEMPLATE: ENTITY_NAMES.ORDER_TEMPLATE,
  ADD_ORDER_TEMPLATE: `Add ${ENTITY_NAMES.ORDER_TEMPLATE}`,
  WORK_ORDER_TEMPLATES: ENTITY_NAMES.WORK_ORDER_TEMPLATES,
  WORK_ORDER_TEMPLATE: ENTITY_NAMES.WORK_ORDER_TEMPLATE,
  ADD_WORK_ORDER_TEMPLATE: `Add ${ENTITY_NAMES.WORK_ORDER_TEMPLATE}`,
  WORK_ORDER_STEPS: `${ENTITY_NAMES.WORK_ORDER} Steps`,
  WORK_ORDER_STEP: `${ENTITY_NAMES.WORK_ORDER} Step`,
  ADD_WORK_ORDER_STEP: `Add ${ENTITY_NAMES.WORK_ORDER} Step`,
  BUILD_CALENDAR: "Build Calendar",
  CREATE_TEAM: "Create Team",
  CALENDARS: "Calendars",
  LABOR_RATES: "Labor Rates",
  QB_INTEGRATION: "Quick Books Integration",
  QB_IMPORT: "Quick Books Import",
  COMMUNITIES: "Communities",
  COMMUNITY: "Community",
  DISPATCH: "Dispatch",
  CONFIGURATION: "Configuration",
  PRICING: "Pricing",
  BIDS: "Bids",
  BID: "Bid",
  INSPECTIONS: "Inspections",
  INSPECTION: "Inspection",
  NEW_INSPECTION: "New Inspection",
  PROFILE: "Profile",
  RECORDABLES: "Recordables",
  WARRANTY_ITEMS: "Warranty Items",
  HOMES: "Homes",
  HOMES_LIST: "Homes List",
  ORDERS: "Orders",
  ORDERS_LIST: "Orders List",
  NEW_ORDER: "New Order",
  SETTINGS: "Settings",
  ITEMS: "Items",
  ITEM: "Item",
  ADD_ITEM: "Add Item",
  ATTRIBUTES: "Attributes",
  ATTRIBUTE: "Attribute",
  ADD_ATTRIBUTE: "Add Attribute",
  CATEGORIES: "Categories",
  CATEGORY: "Category",
  ADD_CATEGORY: "Add Category",
  AREAS: "Areas",
  AREA: "Area",
  ADD_AREA: "Add Area",
  ADDERS: "Adders",
  ADDER: "Adder",
  ADD_ADDER: "Add Adder",
  REQUIREMENTS: "Requirements",
  REQUIREMENT: "Requirement",
  ADD_REQUIREMENT: "Add Requirement",
  CUSTOMER_PRICING: "Customer Pricing",
  DROP_TYPES: "Drop Types",
  DROP_TYPE: "Drop Type",
  ADD_DROP_TYPE: "Add Drop Type",
  PRICING_MATRIX: "Pricing Matrix",
  INSPECTION_TEMPLATES: ENTITY_NAMES.INSPECTION_TEMPLATES,
  INSPECTION_TEMPLATE: ENTITY_NAMES.INSPECTION_TEMPLATE,
  ADD_INSPECTION_TEMPLATE: `Add ${ENTITY_NAMES.INSPECTION_TEMPLATE}`,
  CITIES: "Cities",
  CITY: "City",
  ADD_CITY: "Add City",
  INSPECTION_AUTHORITIES: "Inspection Authorities",
  INSPECTION_AUTHORITY: "Inspection Authority",
  ADD_INSPECTION_AUTHORITY: "Add Inspection Authority",
  CANNOT_PERFORM_REASONS: "Cannot Perform Reasons",
};
